// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
// The gesso design system: basecoat behaviour + Stimulus controllers.
import "gesso"
import "./controllers"

// Times render in UTC and are drawn in the reader's own zone here.
import LocalTime from "local-time"
LocalTime.start()
